import { defineAction } from '~/prix'
import { z } from 'zod'
import collectedAnimalDeleteAction from './collectedAnimalDelete.action.json' with { type: 'json' }
import { collectedAnimalObject } from '../collectedAnimalObject'

const collectedAnimalDeleteDefinition = defineAction({
  ...collectedAnimalDeleteAction,

  input: z.object({ id: collectedAnimalObject.shape.id }),
  output: z.object({}),
})

export default collectedAnimalDeleteDefinition
